import React from "react";
import styles from "./index.module.scss";

export default function NewNoteButton({
  numberOfNewNotes,
  addNewNote,
}: {
  numberOfNewNotes: number;
  addNewNote: () => void;
}) {
  return (
    <div className={styles.box} data-e="new-notes-info-btn">
      <a href="#topRTC" className={`${styles.btn} ${numberOfNewNotes ? styles.btn_show : ""}`} onClick={addNewNote}>
        Zobacz nowe wiadomości
        <span className={styles.btn__number}>({numberOfNewNotes})</span>
      </a>
    </div>
  );
}
